import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Header,
  Form,
  Segment,
  Button,
  Message
} from "semantic-ui-react";
import UserAuthStore from "../../app/stores/userauthStore";
import { Redirect } from "react-router";
import { observer } from "mobx-react-lite";

const Login = () => {
  //let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  const userauthStore = useContext(UserAuthStore);
  const [password, setPassword] = useState();
  const [username, setUsername] = useState();

  const handleUserChange = (val: any) => {
    setUsername(val.target.value);
  };

  const handlePassChange = (val: any) => {
    setPassword(val.target.value);
  };

  const sendLogin = (e: any, data: any) => {
    if (password != null && username != null) {
      userauthStore.LoginUser(username, password);
    }
  };

  // useEffect(() => {}, [userauthStore.authMessage]);

  if (userauthStore.isLoggedIn  === true) {
    return <Redirect to="/" />;
  }
  return (
    <Grid textAlign="center" style={{ height: "100vh" }}>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" textAlign="center">
          Client Portal
        </Header>
        <p>Please login to access features.</p>

        <Form size="large">
          <Segment stacked>
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
              onChange={handleUserChange}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={handlePassChange}
            />

            {userauthStore.isLoggingIn === true ? (
              <Button loading fluid size="large" onClick={sendLogin}>
                Please Wait...
              </Button>
            ) : (
              <Button fluid size="large" onClick={sendLogin}>
                Login
              </Button>
            )}
          </Segment>
        </Form>
        <Message>{userauthStore.authMessage}</Message>
      </Grid.Column>
    </Grid>
  );
};




export default observer(Login);
